import { useState, useRef } from "react";
import { IMAGES } from "../data/site";
import { Reveal } from "./Reveal";
import { MoveHorizontal } from "lucide-react";

export default function BeforeAfter() {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);

  const move = (clientX) => {
    const rect = ref.current.getBoundingClientRect();
    let p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, p)));
  };

  return (
    <section className="py-24 sm:py-32 bg-[#1B1B1B]" data-testid="before-after-section">
      <div className="container-lux">
        <Reveal className="max-w-3xl mb-12">
          <p className="overline mb-3">Before &amp; After</p>
          <h2 className="font-head text-4xl sm:text-5xl uppercase tracking-tight">
            See the <span className="text-gold-metallic">transformation.</span>
          </h2>
        </Reveal>

        <Reveal>
          <div ref={ref}
            data-testid="before-after-slider"
            className="relative w-full aspect-[16/9] rounded-md overflow-hidden select-none cursor-ew-resize border border-white/10"
            onMouseMove={(e) => e.buttons === 1 && move(e.clientX)}
            onClick={(e) => move(e.clientX)}
            onTouchMove={(e) => move(e.touches[0].clientX)}
          >
            <img src={IMAGES.after} alt="After — the same house with a brand new roof, fascias and guttering" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
            <span className="absolute top-4 right-4 z-10 text-xs uppercase tracking-widest bg-[#D4AF37] text-black px-3 py-1 rounded-full">After</span>

            <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
              <img src={IMAGES.before} alt="Before — tired, weathered roof with slipped tiles" loading="lazy" className="absolute inset-0 h-full object-cover" style={{ width: ref.current ? ref.current.offsetWidth : "100%", maxWidth: "none" }} />
              <span className="absolute top-4 left-4 z-10 text-xs uppercase tracking-widest bg-black/60 px-3 py-1 rounded-full">Before</span>
            </div>

            <div className="absolute top-0 bottom-0 w-[2px] bg-[#D4AF37]" style={{ left: `${pos}%` }}>
              <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-11 h-11 rounded-full btn-gold flex items-center justify-center">
                <MoveHorizontal size={20} className="text-black" />
              </span>
            </div>
          </div>
          <p className="text-center text-sm text-[#C8C8C8] mt-4">Drag or tap to reveal — a complete roof replacement transformation on the same property.</p>
        </Reveal>
      </div>
    </section>
  );
}
